// extracted by mini-css-extract-plugin
export default {"pointWrapper":"mnU1d","pointWrapperQuestion":"rsXL3","pointWrapperAnswer":"Jd2pM","point":"mlrFC","pointCurrent":"K46Hc","dot":"MErJ3","pointSuccess":"rwHiY","pointError":"E6xzo"};